export class AfectoIgv {
    n?:string;
    id?:string;
    descrip?:string;
    codigo?:string;
    constructor(){}
}
